

export class GeoFenceOutputWithStatus implements IGeoFenceOutputWithStatus {
    /** The auto-generated id of the geofence master */
    geofence_id!: number;
    /** The place name with 255 character limit */
    name!: string;
    /** The description with 5000 character limit */
    description!: string;
    /** The tolerance of selected place */
    tolerance!: number;
    /** Selection on company it will be all or it will be company details id character limit */
    company!: string;
    /** Selection on branch it will be all or it will be branch details id character limit */
    branch!: string;
    /** The geofence data */
    geofence_data!: string;
    /** The shapeData data */
    shape_data!: string;
    /** Selected category for geofence */
    category!: string;
    /** The flag for show geofence */
    show_geofence!: number;
    /** The consider for trip */
    consider_for_trip!: number;
    /** Fence type */
    fence_type!: string;
    /** The color with 255 character limit */
    color!: string;
    /** The status of poi details should be 0 or 1 */
    status!: number;

    constructor(data?: IGeoFenceOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.geofence_id = _data["geofence_id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.tolerance = _data["tolerance"];
            this.company = _data["company"];
            this.branch = _data["branch"];
            this.geofence_data = _data["geofence_data"];
            this.shape_data = _data["shape_data"];
            this.category = _data["category"];
            this.show_geofence = _data["show_geofence"];
            this.consider_for_trip = _data["consider_for_trip"];
            this.fence_type = _data["fence_type"];
            this.color = _data["color"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): GeoFenceOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new GeoFenceOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geofence_id"] = this.geofence_id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tolerance"] = this.tolerance;
        data["company"] = this.company;
        data["branch"] = this.branch;
        data["geofence_data"] = this.geofence_data;
        data["shape_data"] = this.shape_data;
        data["category"] = this.category;
        data["show_geofence"] = this.show_geofence;
        data["consider_for_trip"] = this.consider_for_trip;
        data["fence_type"] = this.fence_type;
        data["color"] = this.color;
        data["status"] = this.status;
        return data; 
    }
}

export interface IGeoFenceOutputWithStatus {
    /** The auto-generated id of the geofence master */
    geofence_id: number;
    /** The place name with 255 character limit */
    name: string;
    /** The description with 5000 character limit */
    description: string;
    /** The tolerance of selected place */
    tolerance: number;
    /** Selection on company it will be all or it will be company details id character limit */
    company: string;
    /** Selection on branch it will be all or it will be branch details id character limit */
    branch: string;
    /** The geofence data */
    geofence_data: string;
    /** The shapeData data */
    shape_data: string;
    /** Selected category for geofence */
    category: string;
    /** The flag for show geofence */
    show_geofence: number;
    /** The consider for trip */
    consider_for_trip: number;
    /** Fence type */
    fence_type: string;
    /** The color with 255 character limit */
    color: string;
    /** The status of poi details should be 0 or 1 */
    status: number;
}

